import { storeGetters } from "../../getters.constants.js";

const snackbarGetters = {
  // Get Role
  [storeGetters.getSnackbarText]: (state) => {
    return state.snackbarText;
  }
};
export default { ...snackbarGetters };
